module.exports = __webpack_public_path__ + "img/swiper-left.c039601.svg";